import React, { Component, Fragment, useEffect, useState } from 'react'
import Counter from "./counter";
import ProgressBar from "@ramonak/react-progress-bar";
import DonationButton from "./donation-button";
import RenderConfetti from "./confetti";
import { t } from "@lingui/core/macro";
import { getPrimaryColor } from "../tokens";

export default function BarCount({ context, campagneData, campagneTarget }) {

    const isMobile = context.isMobile
    const total = campagneData.stats.total.count.total

    let bonus = null
    let _objectif = campagneData.objectif
    if (_objectif <= total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length > 0) {
        bonus = campagneData.bonus.find(b => b > total)
        if (!bonus) {
            bonus = campagneData.bonus.at(-1)
        }
    }
    if (bonus) {
        _objectif = bonus
    }

    const percent = (_objectif>0 ? (total / _objectif) * 100 : 0)
    const displayPercent = (Number(campagneData.objectif)>0 ? (total / campagneData.objectif) * 100 : 0)

    let progressColor = getPrimaryColor(campagneData.config)

    const formater = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 })

    let donorName = campagneData.config?.donorName || t`Donateurs`

    if (isMobile) {
        return (
            <div className={"bar"} style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around",
                padding: "30px 15px",
                color: "#FFF"
            }}>

                <div className={"container d-flex flex-column justify-content-around align-items-center"}>
                    <span dir={"ltr"} className="bar-text-primary" style={{ fontSize: "2.7rem", fontWeight: 900, marginBottom: 15 }}>
                        <Counter number={total} decimals={0} /> {context.getDonorName(formater.format(total))}
                    </span>

                    <div className={"d-flex justify-content-center align-items-center"} style={{ marginBottom: 25 }}>
                        <ProgressBar
                            customLabel={" "}
                            animateOnRender
                            completed={percent >= 10 ? percent : 10}
                            width={"70vw"}
                            height={"1.7rem"}
                            bgColor={progressColor}
                        />
                        <span className="bar-text-primary" style={{ fontSize: "1.7rem", fontWeight: 900, marginLeft: 10 }}>
                            <Counter number={displayPercent >= 1 ? Math.floor(displayPercent) : displayPercent} decimals={displayPercent >= 1 ? 0 : 1} />%
                        </span>
                    </div>

                    {!bonus && (
                        <div className={"d-flex justify-content-center align-items-center"}>
                            <span className="bar-text-primary"
                                  style={{ fontSize: "1.4rem", fontWeight: 900, marginRight: 5 }}>{t`OBJECTIF :`}</span>

                            <span className="bar-text-secondary" style={{
                                fontSize: "1.7rem",
                                fontWeight: 900,
                            }}>{formater.format(campagneData.objectif)} {context.getDonorName(formater.format(campagneData.objectif))}</span>
                        </div>
                    )}

                    {bonus && (
                        <div className={"d-flex justify-content-center align-items-center"}>
                            <span className="bar-text-primary"
                                  style={{ fontSize: "1rem", fontWeight: 900, marginRight: 5 }}>{t`NOUVEL OBJECTIF :`}</span>

                            <span style={{
                                color: "#5cb85c",
                                fontSize: "1.7rem",
                                fontWeight: 900,
                            }}>{formater.format(_objectif)} {context.getDonorName(formater.format(_objectif))}</span>
                        </div>
                    )}

                </div>

                {(displayPercent >= 100) && (
                    <RenderConfetti />
                )}
            </div>
        )
    }

    return (
        <div className={"bar"} style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            padding: 10,
            color: "#FFF"
        }}>

            <div className={"d-flex justify-content-center align-items-center"} style={{ gap: 50 }}>

                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                    <span dir={"ltr"} className="bar-text-primary" style={{ fontSize: "3rem", fontWeight: 900 }}>
                        <Counter number={total} decimals={0} />
                    </span>

                    <span className="bar-text-secondary" style={{ fontSize: "2rem", fontWeight: 900, marginLeft: 10 }}>/</span>

                    {!bonus && (
                        <span className="bar-text-secondary" style={{ fontSize: "2rem", fontWeight: 900, marginLeft: 10 }}>
                            {formater.format(campagneData.objectif)} {context.getDonorName(formater.format(campagneData.objectif))}
                        </span>
                    )}

                    {bonus && (
                        <Fragment>
                            <span className="bar-text-secondary" style={{
                                fontSize: "2rem",
                                fontWeight: 900,
                                marginLeft: 10,
                                textDecorationLine: "line-through"
                            }}>{formater.format(campagneData.objectif)}</span>

                            <span style={{
                                color: "#5cb85c",
                                fontSize: "2.5rem",
                                fontWeight: 900,
                                marginLeft: 10,
                            }}>{formater.format(_objectif)} {context.getDonorName(formater.format(_objectif))}</span>
                        </Fragment>
                    )}

                </div>

                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <ProgressBar
                        customLabel={" "}
                        animateOnRender
                        completed={percent >= 10 ? percent : 10}
                        width={"15rem"}
                        height={"1.5rem"}
                        bgColor={progressColor}
                    />

                    <span className="bar-text-primary" style={{ fontSize: "2rem", fontWeight: 900, marginLeft: 10 }}>
                        <Counter number={displayPercent >= 1 ? Math.floor(displayPercent) : displayPercent} decimals={displayPercent >= 1 ? 0 : 1} />%
                    </span>
                </div>

                <DonationButton context={context} campagneData={campagneData} campagneTarget={campagneTarget} />
            </div>

            {(displayPercent >= 100) && (
                <RenderConfetti />
            )}
        </div>
    )
}
